/* eslint-disable jsx-a11y/no-distracting-elements */
import React from 'react'
import Marquee from 'react-fast-marquee'
import { useAppSelector } from '../../../state/AppStore'
import './Marquee.scss'

export default () => {
	const msg = useAppSelector((state) => state.appConfig.adminMessage)

	return (
		<Marquee className='mvp-marquee' gradient={false} speed={40} style={{ position: 'absolute' }}>
			{msg?.valid && `${msg.message}`}
		</Marquee>
	)
}
